import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingOverlay from "../../components/LoadingOverlay";
import Loader from "../../components/Loader";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong</h1>;
    }
    return this.props.children;
  }
}

const LoadingAndErrorHandling = ({
  error,
  loading = false,
  children,
  displayChildrenWhileLoading = false,
  useFullscreenLoader = false
}) => {
  const hasError = !!error;

  return (
    <ErrorBoundary>
      {hasError && error.toString()}
      {!hasError && loading && useFullscreenLoader && <Loader />}
      {!hasError && loading && !useFullscreenLoader && <LoadingOverlay />}
      {!hasError && (!loading || displayChildrenWhileLoading) && children}
    </ErrorBoundary>
  );
};

LoadingAndErrorHandling.propTypes = {
  loading: PropTypes.bool,
  useFullscreenLoader: PropTypes.bool,
  displayChildrenWhileLoading: PropTypes.bool,
  error: PropTypes.shape({ toString: PropTypes.func.isRequired }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export { ErrorBoundary };
export default LoadingAndErrorHandling;
